/* eslint-disable react/require-default-props */
import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

export function ButtonCorrecao({ setOpenModal, loading, text }) {
  return <Button
    style={{
      background: '#24A95D',
      border: 'none',
      fontWeight: 'bold',
      borderRadius: '0px',
    }}
    type="primary"
    size="small"
    loading={loading}
    onClick={() => setOpenModal(true)}
  >
    {text}
         </Button>;
}

ButtonCorrecao.propTypes = {
  setOpenModal: PropTypes.func,
  loading: PropTypes.bool,
  text: PropTypes.string,
};
